import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState, Fragment } from 'react';
import { exposeTestId } from '../../config';
import { TableState } from '../../store/birdElement/tableState';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import GestureHelper from '@sas-dvr/ltjs-commons/gestures/GestureHelper';
import { createUniqueId } from '../utils/createUniqueId';
import { selectAccessibilityLabelState, selectLayoutState, selectMessageState, } from '../../store/selectors';
import { useMessageToast } from '../utils/messageToast';
import { MessageState } from '../../store/message/MessageState';
//css
import cn from './BirdTable.css.json';
import './BirdTable.css';
export const BirdTableBase = function ({ id, actions, menuActions, message, messageActions, minWidth, minHeight, accessibilityLabel, }) {
    const [contentId] = useState(createUniqueId);
    useLayoutEffect(function () {
        actions.update(id, { contentId });
        return function () {
            actions.update(id, { contentId: undefined });
        };
    }, [actions, contentId, id]);
    const tableRef = useRef(null);
    const messageToast = useMessageToast({
        message: message,
        referenceElementRef: tableRef,
        onDismiss: () => messageActions.set(id, undefined),
    });
    const style = {};
    if (minWidth) {
        style.minWidth = minWidth + 'px';
    }
    if (minHeight) {
        style.minHeight = minHeight + 'px';
    }
    return (_jsxs(Fragment, { children: [_jsx("div", { id: contentId, "data-testid": exposeTestId() ? contentId : null, className: cn.table, tabIndex: 0, ref: tableRef, "aria-label": accessibilityLabel, style: Object.assign(Object.assign({}, style), { display: 'flex', flexShrink: 1, width: '100%', height: '100%' }), onContextMenu: (e) => {
                    const position = GestureHelper.getMousePosition(e.nativeEvent, e.currentTarget, true);
                    menuActions.setGraphPosition(position);
                } }), messageToast] }));
};
export const BirdTable = connect((state, props) => {
    const constraints = selectLayoutState(state, props.id).constraints;
    return {
        minWidth: constraints === null || constraints === void 0 ? void 0 : constraints.minWidth,
        minHeight: constraints === null || constraints === void 0 ? void 0 : constraints.minHeight,
        accessibilityLabel: selectAccessibilityLabelState(state, props.id),
        message: selectMessageState(state, props.id),
    };
}, (dispatch) => ({
    actions: bindActionCreators(TableState.actions, dispatch),
    messageActions: bindActionCreators(MessageState.actions, dispatch),
    menuActions: bindActionCreators(ReportContextMenuState.actions, dispatch),
}))(BirdTableBase);
